/**
 * Created by neo on 10.01.21.
 */
import { makeAutoObservable } from 'mobx';
import { HttpBackend } from '../../Services/Http/HttpBackend';
import { v1ParamsToV3Params } from './exploreV3Params';
import { ExploreEntryQueryRequest } from './ExploreEntryQueryRequest';
import { ActivityWorkoutEntryBase, createActivityWorkoutEntryBase } from './ActivityWorkoutEntry';
import { MeditationNarrator, createMeditationNarrator } from './MeditationNarrator';

export type MeditationEntry = ActivityWorkoutEntryBase & {
  type: 'meditation';
  narrators: MeditationNarrator[];
};

export function createMeditationEntry(json?: Partial<MeditationEntry>): MeditationEntry {
  const base = createActivityWorkoutEntryBase(json, 'meditation', 'mindAndBody');
  return makeAutoObservable({
    ...base,
    narrators: (json?.narrators ?? []).map((n: any) => createMeditationNarrator(n)),
  });
}

export const MeditationEntryApi = {
  find(request?: Omit<ExploreEntryQueryRequest, 'type'>): Promise<MeditationEntry[]> {
    return HttpBackend.get(`/coach/explore/v3/entries`, v1ParamsToV3Params({ ...request, type: 'meditation' })).then((res) =>
      (res ?? []).map((r: any) => createMeditationEntry(r)),
    );
  },

  findOne(id: string): Promise<MeditationEntry> {
    return HttpBackend.get(`/coach/explore/v3/entries/${id}`).then((res) => createMeditationEntry(res));
  },
};
